import React from 'react';
import { useSelector } from 'react-redux';

import { usePokerPowerPathWidget } from '../../model';
import type { PassBundleRaw, PassTypeKey } from '../../types/';
import PassListCards from '../PassListCards';
import PassListSlider from '../PassListSlider/PassListSlider';

const ThePasses = () => {
  const { widgetSelect } = usePokerPowerPathWidget();
  const passesData: PassBundleRaw = useSelector(widgetSelect.getPasses);

  if (!passesData) {
    return null;
  }

  const passTypes = Object.keys(passesData) as PassTypeKey[];

  return (
    <>
      {passTypes.map((type) => (
        <PassListSlider key={type} type={type}>
          <PassListCards type={type} passData={passesData[type]} />
        </PassListSlider>
      ))}
    </>
  );
};

export default ThePasses;
